import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Divider,
} from "@mui/material";
import { CardIcon } from "src/assets/icons";
import IconsBackground from "src/components/common/Icons/IconsBackground";
import Typography from "@mui/material/Typography";
import styled from "src/components/common/CardSlider/styled";
import SubmitButton from "src/components/common/Buttons/SubmitButton";
import { useRouter } from "next/router";
import Image from "next/image";
import { colors } from "src/config/colors";
import { createUrl } from "src/utils/helpers/url/createUrl";
import paths from "src/router/paths";
import { useQuery } from "src/utils/hooks/common/useQuery";

interface ProductItemCardProps {
  brandName: string;
  formsAmount?: number;
  min_price?: number;
  image?: string;
  slug: string;
  isList?: boolean;
  pharmaciesAmount?: number;
  mnn?: string;
}

const SecondCategoriesCard: React.FC<ProductItemCardProps> = ({
  brandName,
  formsAmount,
  min_price,
  image,
  slug,
  isList,
  pharmaciesAmount,
  mnn,
}) => {
  const router = useRouter();

  const { city } = useQuery(["city"]);

  return (
    <Card
      sx={{
        ...styled.root,
        height: "100%",
      }}
    >
      <CardActionArea
        sx={{ height: "100%", display: "flex", flexDirection: "column" }}
        disableRipple
        onClick={() => router.push(createUrl([city, paths.CATEGORY, slug]))}
      >
        <Image
          width="500px"
          height="500px"
          alt="картинка продукта"
          src={
            image || "https://www.vidal.ru/upload/products/kagocel-10tab.jpg"
          }
        />
        <CardHeader
          sx={{
            ...styled.cardHeader,
            flexDirection: isList ? "row" : "column",
            ".MuiCardHeader-content": { overflow: "hidden" },
            width: "100%",
          }}
          avatar={
            <IconsBackground
              sx={{
                ...styled.avatar,
                marginBottom: isList ? "0px" : "17px",
              }}
              width={45}
              height={45}
            >
              <CardIcon />
            </IconsBackground>
          }
          title={
            <Typography
              sx={{ fontSize: "16px" }}
              variant="h6"
              component="h6"
              gutterBottom
            >
              {brandName}
            </Typography>
          }
          subheader={
            <Typography
              sx={{ fontSize: "12px" }}
              variant="subtitle2"
              component="span"
            >
              {mnn}
            </Typography>
          }
        />
        <Divider flexItem variant="middle" />
        <CardContent sx={{ ...styled.cardContent, width: "100%", flex: "1" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              backgroundColor: colors.gray,
              borderRadius: "3px",
            }}
          >
            <Typography sx={{ padding: "3px 10px" }} fontSize="12px">
              Формы выпуска: {formsAmount}
            </Typography>
          </Box>
        </CardContent>
        <Divider flexItem variant="middle" />
        <Box
          display="flex"
          alignItems="left"
          justifyContent="center"
          flexDirection="column"
          padding="16px 22px"
          width="100%"
        >
          <Typography
            fontSize="12px"
            mb={1}
            sx={{
              backgroundColor: colors.gray,
              borderRadius: "3px",
              padding: "3px 10px",
            }}
          >{`В наличии в (${pharmaciesAmount}) аптеках`}</Typography>
          <SubmitButton
            href={createUrl([city, paths.CATEGORY, slug])}
            height={35}
            title={`Купить от ${min_price} ₽`}
          />
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default SecondCategoriesCard;
